import { hubsMultiSelectIntlIds } from './hubs-multi-select.ids';

export const hubsMultiSelectLangEnUs = {
  [hubsMultiSelectIntlIds.allValuesLabel]: 'All hubs',
  [hubsMultiSelectIntlIds.placeholder]: 'Select one or more hubs',
  [hubsMultiSelectIntlIds.noOptionsLabel]: 'No options available',
};
